import { createRouter, createWebHistory } from "vue-router";
import {
  POSPage,
  OrdersPage,
  TablesPage,
  DevicesPage,
  PaymentTerminalDetails,
  PrinterDetails,
  OverviewPage,
  RevenuePage,
  WeeklyHeatmapPage,
  ReportsPage,
  TransactionHistoryPage,
  ProductsPage,
  CatalogEditorPage,
  TipsSummaryPage,
  ManagerSettingsPage,
  VisualTablesPage,
  ProfileSettings,
  StaffSettings,
  ProductsSubPage,
  CategoriesSubPage,
  ExtrasSubPage,
  ServicesSubPage,
  CatalogOverviewPage,
  HomePage,
  ManagerDashboardPage,
  PrintersSettings,
  TerminalsSettings,
  ConfigSettings,
  LoginPage,
  ManagerTablesPage,
  OnboardingPage,
  AppLanding,
  SignupPage,
  NotFoundPage,
  ManagerPromotionsPage,
  ManagerReservationsPage,
  StaffReservationsPage,
  ClosingReportsPage,
  Application,
  DataExportPage,
  ShiftsReportPage,
  ChartOfAccountsPage,
  DataRoomPage,
  ReservationsReportPage,
  LiveStatusPage,
  LoyaltyPromotionsPage,
  ReservationsSchedulePage,
  ReservationTabsPage,
  ReservationsListPage,
  ReservationsHistoryPage,
  LoyaltyCustomersPage,
  LoyaltyCampaignsPage,
  LoyaltyCampaignStudioPage,
  LoyaltyCoinProgramsPage,
  MembershipProgramsPage,
  LoyaltyAutomationsPage,
  LoyaltyGiftCardsPage,
  LoyaltyWalletDesignsPage,
  ReservationCustomersPage,
  TaxSettings,
  DataDetailPage,
  ReservationSettings,
  AssetsSettings,
  PaymentsSettings,
  EventsManagement,
  DiscountTypesSettings,
  AuditSettings,
  PrintTemplatesSettings,
  AdminLayoutPage,
  AdminDashboardPage,
  AdminRestaurantsPage,
  AdminSettingsPage,
  InventoryPage,
  InventoryOverviewPage,
  InventoryStockPage,
  InventoryCountsPage,
  InventoryPurchasesPage,
  InventoryInvoicesPage,
  InventorySuppliersPage,
  InventoryWastePage,
  InventoryMarginsPage,
  BrowsePage,
  InventoryOrdersPage,
  WorkDayPage,
  WorkDayMyDayPage,
  WorkDayProceduresPage,
  WorkDayPrepPage,
  WorkDayTasksPage,
  WorkDayTeamPage,
  WorkDayRotaPage,
  RotaTemplatesPage,
  RotaSchedulePage,
  TeamLinkPage,
  RotaRequestsPage,
  RotaHoursPage,
  IntelligencePage,
  AgentDirectory,
  ThreadView,
  ProjectSettings,
  GroupApplication,
  GroupDashboardPage,
  GroupOverviewPage,
  GroupRevenuePage,
  GroupDataRoomPage,
  GroupUsersPage,
  GroupSettingsPage,
  GroupBaseSettingsPage,
  GroupLoyaltyPage,
  GroupMembershipProgramsPage,
  GroupCoinProgramsPage,
  GroupWalletDesignsPage,
  GroupAutomationsPage,
  MenuPage,
  GroupMenuPage,
} from "@app/vue/pages/index";

// `meta.fullHeight`: the page fills the viewport under the navbar and scrolls itself (see Layout).
const routes = [
  {
    path: "/",
    component: HomePage,
    meta: { fullHeight: true },
  },
  {
    path: "/login/email",
    component: LoginPage,
    meta: { fullHeight: true },
  },
  {
    path: "/login",
    component: AppLanding,
    meta: { fullHeight: true },
  },
  {
    path: "/signup",
    component: SignupPage,
    meta: { fullHeight: true },
  },
  // A team member's personal rota link (no login). See docs/plans/workday/staff_planning.md.
  {
    path: "/team/:token",
    component: TeamLinkPage,
  },
  {
    path: "/onboarding",
    component: OnboardingPage,
  },
  {
    path: "/app",
    component: Application,
    children: [
      {
        path: "pos",
        component: POSPage,
      },
      {
        path: "manager/dashboard",
        component: ManagerDashboardPage,
      },
      {
        path: "manager/tables",
        component: ManagerTablesPage,
      },
      {
        path: "manager/loyalty",
        component: ManagerPromotionsPage,
        children: [
          {
            path: "promotions",
            alias: "",
            component: LoyaltyPromotionsPage,
          },
          {
            path: "customers",
            component: ReservationCustomersPage,
          },
          {
            path: "campaigns",
            component: LoyaltyCampaignsPage,
          },
          {
            path: "campaign-studio",
            component: LoyaltyCampaignStudioPage,
          },
          {
            path: "coins",
            component: LoyaltyCoinProgramsPage,
          },
          {
            path: "memberships",
            component: MembershipProgramsPage,
          },
          {
            path: "automations",
            component: LoyaltyAutomationsPage,
          },
          {
            path: "gift-cards",
            component: LoyaltyGiftCardsPage,
          },
          {
            path: "wallet",
            component: LoyaltyWalletDesignsPage,
          },
        ],
      },
      {
        path: "manager/reservations",
        component: ManagerReservationsPage,
        children: [
          {
            path: "customers",
            component: ReservationCustomersPage,
          },
          {
            path: "schedule",
            component: ReservationsSchedulePage,
          },
          {
            path: "requests",
            alias: "",
            component: ReservationTabsPage,
          },
          {
            path: "list",
            component: ReservationsListPage,
          },
          {
            path: "history",
            component: ReservationsHistoryPage,
          },
          {
            path: "events",
            component: EventsManagement,
          },
        ],
      },
      {
        path: "staff/reservations",
        component: StaffReservationsPage,
      },
      {
        path: "catalog_editor",
        component: CatalogEditorPage,
        children: [
          { path: "", redirect: "/app/catalog_editor/overview" },
          { path: "overview", component: CatalogOverviewPage },
          {
            path: "services",
            component: ServicesSubPage,
          },
          {
            path: "categories",
            component: CategoriesSubPage,
          },
          {
            path: "products",
            component: ProductsSubPage,
          },
          {
            path: "extras",
            component: ExtrasSubPage,
          },
        ],
      },
      {
        path: "orders",
        component: OrdersPage,
      },
      {
        path: "tables",
        component: TablesPage,
      },
      {
        path: "rooms",
        component: VisualTablesPage,
      },
      {
        path: "products",
        component: ProductsPage,
      },
      {
        path: "transactions",
        component: TransactionHistoryPage,
      },
      {
        path: "devices",
        component: DevicesPage,
        children: [
          {
            path: "printer/:id",
            component: PrinterDetails,
          },
          {
            path: "payment_terminal/:id",
            component: PaymentTerminalDetails,
          },
        ],
      },
      {
        path: "inventory",
        component: InventoryPage,
        children: [
          { path: "", redirect: "/app/inventory/overview" },
          { path: "overview", component: InventoryOverviewPage },
          { path: "stock", component: InventoryStockPage },
          { path: "counts", component: InventoryCountsPage },
          { path: "orders", component: InventoryOrdersPage },
          { path: "deliveries", component: InventoryPurchasesPage },
          { path: "purchases", redirect: "/app/inventory/deliveries" },
          { path: "invoices", component: InventoryInvoicesPage },
          { path: "suppliers", component: InventorySuppliersPage },
          { path: "waste", component: InventoryWastePage },
          { path: "margins", component: InventoryMarginsPage },
          { path: "marketplace", component: BrowsePage },
          {
            path: "marketplace/orders",
            redirect: "/app/inventory/orders?source=marketplace",
          },
        ],
      },
      {
        path: "workday",
        component: WorkDayPage,
        children: [
          { path: "", redirect: "/app/workday/myday" },
          { path: "myday", component: WorkDayMyDayPage },
          { path: "procedures", component: WorkDayProceduresPage },
          { path: "prep", component: WorkDayPrepPage },
          { path: "tasks", component: WorkDayTasksPage },
          { path: "team", component: WorkDayTeamPage },
          {
            path: "rota",
            component: WorkDayRotaPage,
            children: [
              { path: "", redirect: "/app/workday/rota/schedule" },
              { path: "schedule", component: RotaSchedulePage },
              { path: "requests", component: RotaRequestsPage },
              { path: "hours", component: RotaHoursPage },
              { path: "templates", component: RotaTemplatesPage },
            ],
          },
        ],
      },
      // Marketplace became a subpage of Inventory; keep old links working.
      { path: "marketplace", redirect: "/app/inventory/marketplace" },
      { path: "marketplace/browse", redirect: "/app/inventory/marketplace" },
      {
        path: "marketplace/orders",
        redirect: "/app/inventory/orders?source=marketplace",
      },
      {
        path: "intelligence",
        component: IntelligencePage,
        children: [
          {
            path: "",
            component: AgentDirectory,
          },
          {
            path: "projects/:projectId/threads/new",
            component: ThreadView,
          },
          {
            path: "projects/:projectId/threads/:threadId",
            component: ThreadView,
          },
          {
            path: "projects/:projectId/settings",
            component: ProjectSettings,
          },
        ],
      },
      {
        path: "admin",
        component: AdminLayoutPage,
        children: [
          {
            path: "dashboard",
            alias: "",
            component: AdminDashboardPage,
          },
          {
            path: "restaurants",
            component: AdminRestaurantsPage,
          },
          {
            path: "settings",
            component: AdminSettingsPage,
          },
        ],
      },
      {
        path: "reports",
        component: ReportsPage,
        children: [
          {
            path: "overview",
            alias: "",
            component: OverviewPage,
          },
          {
            path: "revenue",
            component: RevenuePage,
          },
          {
            path: "weekly_heatmap",
            component: WeeklyHeatmapPage,
          },
          {
            path: "tips",
            component: TipsSummaryPage,
          },
          {
            path: "closing_reports",
            component: ClosingReportsPage,
          },
          {
            path: "transactions",
            component: TransactionHistoryPage,
          },
          {
            path: "export",
            component: DataExportPage,
          },
          {
            path: "shifts",
            component: ShiftsReportPage,
          },
          {
            path: "chart_of_accounts",
            component: ChartOfAccountsPage,
          },
          {
            path: "live",
            component: LiveStatusPage,
          },
          {
            path: "reservations",
            component: ReservationsReportPage,
          },
          {
            path: "dataroom",
            component: DataRoomPage,
          },
          {
            path: "data",
            component: DataDetailPage,
          },
        ],
      },
      {
        path: "menu",
        component: MenuPage,
      },
      {
        path: "settings",
        component: ManagerSettingsPage,
        children: [
          {
            path: "profile",
            component: ProfileSettings,
          },
          {
            path: "taxes",
            component: TaxSettings,
          },
          {
            path: "config",
            alias: "",
            component: ConfigSettings,
          },
          {
            path: "reservations",
            component: ReservationSettings,
          },
          {
            path: "assets",
            component: AssetsSettings,
          },
          {
            path: "discount-types",
            component: DiscountTypesSettings,
          },
          {
            path: "printers",
            component: PrintersSettings,
          },
          {
            path: "terminals",
            component: TerminalsSettings,
          },
          {
            path: "staff",
            component: StaffSettings,
          },
          {
            path: "payments",
            component: PaymentsSettings,
          },
          {
            path: "print-templates",
            component: PrintTemplatesSettings,
          },
          {
            path: "audit",
            component: AuditSettings,
          },
        ],
      },
    ],
  },
  {
    path: "/group",
    component: GroupApplication,
    children: [
      {
        path: "",
        redirect: "/group/dashboard",
      },
      {
        path: "dashboard",
        component: GroupDashboardPage,
        children: [
          {
            path: "",
            component: GroupOverviewPage,
          },
          {
            path: "revenue",
            component: GroupRevenuePage,
          },
          {
            path: "dataroom",
            component: GroupDataRoomPage,
          },
        ],
      },
      {
        path: "shops",
        redirect: "/group/dashboard",
      },
      {
        path: "loyalty",
        component: GroupLoyaltyPage,
        children: [
          {
            path: "",
            redirect: "/group/loyalty/memberships",
          },
          {
            path: "memberships",
            component: GroupMembershipProgramsPage,
          },
          {
            path: "coins",
            component: GroupCoinProgramsPage,
          },
          {
            path: "wallet",
            component: GroupWalletDesignsPage,
          },
          {
            path: "automations",
            component: GroupAutomationsPage,
          },
        ],
      },
      {
        path: "menu",
        component: GroupMenuPage,
      },
      {
        path: "users",
        redirect: "/group/settings/users",
      },
      {
        path: "settings",
        component: GroupSettingsPage,
        children: [
          {
            path: "",
            component: GroupBaseSettingsPage,
          },
          {
            path: "users",
            component: GroupUsersPage,
          },
          {
            // Group-owned assets, reusing the shop manager in group mode.
            path: "assets",
            component: AssetsSettings,
            props: { mode: "group" },
          },
        ],
      },
    ],
  },
  { path: "/:pathMatch(.*)*", name: "not-found", component: NotFoundPage },
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
});
